import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, catchError, map, throwError } from 'rxjs';
import { AppErrors } from '@fitness-force/models';
import { CONST_URL_SEGEMENTS } from '@fitness-force/constants';
import {
  FormFolder,
  FormFolderCreateRequest,
  FormFolderListResponse,
  FormFolderUpdateRequest,
} from '../models';
import { environment } from '@fitness-force/environments';

@Injectable({
  providedIn: 'root',
})
export class FormFolderService {
  private readonly http = inject(HttpClient);
  private readonly API_BASE_URL = environment.BASE_URL;

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  listFolders(tenantId: string): Observable<FormFolderListResponse> {
    return this.http.get<FormFolderListResponse>(
      this.API_BASE_URL +
        CONST_URL_SEGEMENTS.SURVEY.LIST_FORM_FOLDERS.replace(
          '{tenant_id}',
          tenantId,
        ),
      { headers: this.httpOptions.headers }
    ).pipe(
      map((res: any) => res),
      catchError((error: any) => {
        console.error('List Form Folders API request failed:', error);
        return throwError(() => new AppErrors(error));
      })
    );
  }

  createFolder(
    tenantId: string,
    payload: FormFolderCreateRequest,
  ): Observable<{ id: string; message: string }> {
    return this.http.post<{ id: string; message: string }>(
      this.API_BASE_URL +
        CONST_URL_SEGEMENTS.SURVEY.CREATE_FORM_FOLDER.replace(
          '{tenant_id}',
          tenantId,
        ),
      payload,
      { headers: this.httpOptions.headers }
    ).pipe(
      map((res: any) => res),
      catchError((error: any) => {
        console.error('Create Form Folder API request failed:', error);
        return throwError(() => new AppErrors(error));
      })
    );
  }

  updateFolder(
    tenantId: string,
    folderId: string,
    payload: FormFolderUpdateRequest,
  ): Observable<{ id: string; message: string }> {
    return this.http.put<{ id: string; message: string }>(
      this.API_BASE_URL +
        CONST_URL_SEGEMENTS.SURVEY.UPDATE_FORM_FOLDER.replace(
          '{tenant_id}',
          tenantId,
        ).replace('{folder_id}', folderId),
      payload,
      { headers: this.httpOptions.headers }
    ).pipe(
      map((res: any) => res),
      catchError((error: any) => {
        console.error('Update Form Folder API request failed:', error);
        return throwError(() => new AppErrors(error));
      })
    );
  }

  deleteFolder(
    tenantId: string,
    folderId: string,
  ): Observable<{ message: string }> {
    return this.http.delete<{ message: string }>(
      this.API_BASE_URL +
        CONST_URL_SEGEMENTS.SURVEY.DELETE_FORM_FOLDER.replace(
          '{tenant_id}',
          tenantId,
        ).replace('{folder_id}', folderId),
      { headers: this.httpOptions.headers }
    ).pipe(
      map((res: any) => res),
      catchError((error: any) => {
        console.error('Delete Form Folder API request failed:', error);
        return throwError(() => new AppErrors(error));
      })
    );
  }
}
